import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  // Legacy fallback: older sessions kept the token in localStorage. New sessions use an
  // httpOnly cookie (sent automatically via withCredentials), so this is a no-op for them.
  const token = localStorage.getItem("jotbay_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("jotbay_token");
      if (!window.location.pathname.startsWith("/login") &&
          !window.location.pathname.startsWith("/shared") &&
          window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const apiError = (err, fallback = "Something went wrong.") => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((e) => e?.msg || String(e)).join("; ") || fallback;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") return d.msg || fallback;
  return fallback;
};

export default api;
